import React from 'react'
import { useAgentChatSession } from '@/features/medconnect-agent/model/useAgentChatSession'
import { AgentChatLayout } from '@/features/medconnect-agent'

export function MedConnectAgentChatPage() {
  const session = useAgentChatSession({ basePath: '/medconnect-agent', agentType: 'platform-supervisor' })

  return <AgentChatLayout {...session} agentType="platform-supervisor" />
}
